import { AnyObject } from '@xbcb/shared-types';

const omitTypename = (key: string, value: any) =>
  key === '__typename' ? undefined : value;

export const stripTypeNames = (object: AnyObject) =>
  JSON.parse(JSON.stringify(object), omitTypename);
